var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","overflow-x":"hidden"},attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }